import useIntersectionObserver from '~/lib/hooks/useIntersectionObserver';
import { useLatestNoteTemplateRevisionsWithLegacyHandling } from '~/components/maud/patients/note/useLatestNoteTemplateRevisionsWithLegacyHandling';
import { PatientNoteListItemType } from '~/lib/constants/AddPatientNoteModal.constants';
import { ChakraBox } from '@equip.health/ui';
import Loading from '~/pages/loading';
import PatientNoteTreatmentOverviewSection from '~/components/maud/patients/profile/tabs/patientNotesTab/PatientNoteTreatmentOverviewSection';

type Props = {
  note: PatientNoteListItemType;
};

export const PatientNoteTreatmentOverviewContainer = ({ note }: Props) => {
  const { noteExternalId, noteTemplateRevision, patientExternalId } = note;
  const TOP_LEVEL_ID = `patient-note-item__${noteExternalId}`;
  const {
    visibleRef: treatmentOverviewRef,
    isVisible: isTreatmentOverviewVisible,
  } = useIntersectionObserver();

  const { noteTemplateRevisions, isRevisionDataLoading } =
    useLatestNoteTemplateRevisionsWithLegacyHandling(
      noteTemplateRevision?.templateRevisionId,
    );
  const shouldShowTreatmentOverview = noteTemplateRevisions?.find(
    (rev) =>
      rev.templateRevisionId === noteTemplateRevision?.templateRevisionId,
  )?.template.showTreatmentOverview;

  return (
    <ChakraBox
      data-testid={`${TOP_LEVEL_ID}__treatment-overview__container`}
      marginBottom="12px"
      ref={treatmentOverviewRef}
    >
      {isRevisionDataLoading && isTreatmentOverviewVisible && <Loading />}
      {!isRevisionDataLoading &&
        isTreatmentOverviewVisible &&
        shouldShowTreatmentOverview && (
          <PatientNoteTreatmentOverviewSection
            id={`${TOP_LEVEL_ID}__treatment-overview`}
            noteId={noteExternalId}
            patientId={patientExternalId}
          />
        )}
    </ChakraBox>
  );
};
